define('frontend-common-components/gettingStartedPanel/js/views/collections/actionItemCollectionView',[
    'marionette',
    '../items/actionItemView',
    'underscore'
], function(Marionette, ActionItemView, _) {
    return Marionette.CollectionView.extend({
        tagName: 'ol',
        childView: ActionItemView,
        defaults: {
            modelViewOptions: []
        },
        
        initialize: function(options) {
            _.defaults(options, this.defaults);
            _.each(_.keys(this.defaults), function(key) {
                this[key] = this.options[key];
            }, this);
        },

        childViewOptions: function(model, index) {
            var options = this.modelViewOptions[index];
            if (_.isUndefined(options)) {
                return {};
            } else {
                return options;
            }
        }
    });
});
